import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.9004 4.71191V17.1055L11.8945 17.1025L7.02148 19.7002L7.9707 14.3018L4 10.4199L9.48145 9.625L11.8945 4.7002L11.9004 4.71191Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8942 4.69995L9.48116 9.62532L4 10.4201L7.97062 14.302L7.02147 19.7L11.8942 17.1023L16.7679 19.7L15.8258 14.302L19.7895 10.4201L14.3387 9.62532L11.8942 4.69995Z",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }